import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { DashboardLayout } from '@components'
import { HandleDeleteTicketModalProvider, HandleTicketModalProvider } from '@contexts'

import { DeleteTicketNotificationProvider } from '../../contexts/DeleteTicketNotificationContext'
import { SupplierMenu } from './SupplierMenu'

dayjs.extend(isoWeek)

const SuppliersRouter = () => {
  const { t } = useTranslation()

  const selectOptions = [{ value: 'ticketId', label: t('train_id') }]

  return (
    <DeleteTicketNotificationProvider>
      <HandleTicketModalProvider>
        <HandleDeleteTicketModalProvider>
          <DashboardLayout menu={SupplierMenu} searchSelectOptions={selectOptions}>
            <Outlet />
          </DashboardLayout>
        </HandleDeleteTicketModalProvider>
      </HandleTicketModalProvider>
    </DeleteTicketNotificationProvider>
  )
}

export { SuppliersRouter }
